import React from "react"

const NotificationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <rect width="60" height="60" rx="30" fill="#023648" />
      <rect
        x="0.5"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        stroke="white"
        strokeOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.778 18.8266C40.2345 18.1353 40.0441 17.2048 39.3528 16.7484C38.6614 16.2919 37.731 16.4823 37.2745 17.1737L36.5934 18.2054C36.1369 18.8968 36.3273 19.8272 37.0186 20.2837C37.71 20.7401 38.6404 20.5497 39.0969 19.8584L39.778 18.8266ZM39.2367 23.3361C38.8225 22.6187 39.0684 21.7013 39.7857 21.2871L41.2222 20.4577C41.9397 20.0435 42.8571 20.2893 43.2712 21.0067C43.6855 21.7242 43.4397 22.6416 42.7222 23.0558L41.2857 23.8852C40.5684 24.2994 39.651 24.0535 39.2367 23.3361ZM32.9661 36.0477L39.5905 34.5613C40.578 34.3398 41.0671 33.2241 40.5612 32.3476L32.1015 17.6951C31.5955 16.8187 30.3847 16.6845 29.6991 17.4289L16.0792 32.2167C14.87 33.5295 14.6544 35.4757 15.5467 37.0213C16.423 38.539 18.1679 39.3247 19.8794 38.9827C20.0164 39.3726 20.1913 39.7552 20.4055 40.126C22.2694 43.3546 26.3976 44.4607 29.6262 42.5968C32.007 41.2221 33.2337 38.6161 32.9661 36.0477ZM30.0016 36.7128C30.0138 38.0209 29.34 39.2979 28.1262 39.9987C26.3325 41.0343 24.0391 40.4197 23.0035 38.626C22.9452 38.5251 22.8921 38.4225 22.8442 38.3187L30.0016 36.7128ZM40.7712 26.7831C40.7215 25.9562 41.3517 25.2456 42.1786 25.196L43.4127 25.1219C44.2396 25.0722 44.9502 25.7024 44.9998 26.5293C45.0495 27.3562 44.4193 28.0668 43.5925 28.1164L42.3583 28.1905C41.5314 28.2402 40.8208 27.61 40.7712 26.7831Z"
        fill="#2CCCD3"
      />
    </svg>
  )
}

export default NotificationIcon
